import { render, staticRenderFns } from "./MyTaskList.vue?vue&type=template&id=15cc461a&scoped=true"
import script from "./MyTaskList.vue?vue&type=script&lang=js"
export * from "./MyTaskList.vue?vue&type=script&lang=js"
import style0 from "./MyTaskList.vue?vue&type=style&index=0&id=15cc461a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc461a",
  null
  
)

export default component.exports